import React from "react";

import { PrismicColor } from "utils";

import {
  Column,
  Columns,
  Heading,
  RichText as RichTextComponent,
  Wrapper,
} from "components";

export function RichText({ title, items, background, direction }) {
  if (title || (items && items[0]))
    return (
      <Wrapper
        id={title && title.text}
        py={{ _: "layout.5", md: "layout.6" }}
        bg={PrismicColor(background)}
      >
        <Columns spaceX="layout.5" spaceY="layout.4">
          {/* Title */}
          <Column width={{ _: 1 / 1, lg: 4 / 12 }}>
            {title && title.text && (
              <Heading children={title.text} as="h2" size={700} />
            )}
          </Column>

          {/* Items */}
          <Column width={{ _: 1 / 1, lg: 8 / 12 }}>
            <Columns spaceX="layout.2" spaceY="layout.3">
              {items &&
                items.map((item, i) => {
                  if (item && item.content && item.content.html)
                    return (
                      <Column
                        key={`item-${i}`}
                        width={{ _: 1 / 1, md: direction ? 1 / 2 : 1 / 1 }}
                      >
                        <RichTextComponent
                          html={item.content.html}
                          size={400}
                          maxWidth="65ch"
                        />
                      </Column>
                    );
                  else return null;
                })}
            </Columns>
          </Column>
        </Columns>
      </Wrapper>
    );
  else return null;
}
